import PropTypes from 'prop-types'
import styled from 'styled-components'
import { t, jt } from 'ttag'

import { features } from '@h2/components/media'
import { PG } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Box } from '@h2/components/layout/box'
import { Panel as PanelComponent } from '@h2/common/components/panel'

const Panel = styled(PanelComponent)`
  @media (${features.minWidth.desktop}) {
    h2 {
      font-size: 40px;
      text-align: left;
      line-height: 46px;
    }

    > div > div {
      padding: 20px 400px 20px 5px;
    }

    @media (${features.maxWidth.widescreen}) {
      h2 {
        text-align: center;

        > span:nth-child(2) {
          &::after {
            content: '\\A';
            white-space: pre;
          }
        }
      }

      > div > div {
        padding: 20px 5px;
      }
    }
  }
`
const Title = ({ systemName, tenantId }) => {
  const system = <span key="systemname">{systemName}</span>
  const goal = <span key="goal">{t`choose a goal`}</span>
  const plan = <span key="plan">{t`make a plan`}</span>

  return (
    <Panel color={/california/.test(tenantId) ? '#225FDE' : PG}>
      <Box py="28px" px="20px">
        <Heading
          removeMargins
          level="2"
          align="center"
          color="#fff"
          weight="light"
          variant="mixed-weight">
          {jt`The ${system} can help you ${goal} and ${plan}`}
        </Heading>
      </Box>
    </Panel>
  )
}

Title.propTypes = {
  tenantId: PropTypes.string.isRequired,
  systemName: PropTypes.string.isRequired
}

export { Title }
